export const enTranslations = {
  agentGrm: {
    ADD_DETAILS: "Add Details",
    CATEGORY: "Category",
    COMMON_SUB_CATEGORY: "Sub-Category",
    COMMON_SUB_SUB_CATEGORY: "Sub-Sub-Category",
    GRIEVANCE_SUBJECT: "Sub-Sub-Category",
    grmApplication: "GRM Application",
    grmApplicationSubText:
      "Choose the Category under which your complaint falls",
    selectCategoryType: "Select Category Type",
    selectSubCategoryType: "Select Sub-Category, Sub-Sub-Category Type",
    categoryType: "Categoy Type",
    governmentSchemesRelated: "Government Schemes Related Services",
    privateSchemeRelated: "Private Schemes Related Services",
    SELECT_SUB_CATEGORY: "Select Sub-Category",
    SELECT_SUB_SUB_CATEGORY: "Select Sub-Sub-Category",
    SELECTED_FILES: "Uploaded Files",
    SUB_CATEGORY: "Sub-Category",
    WRITE_COMMENTS: "Write your comments",
    UPLOAD_FILES: "Upload Files",
    GRM_CREATE_SUCCESS_MSG: "Grievance has been Raised Successfully",
    GRM_TICKET_NUMBER: "Ticket Number",
    COMMON_RESEND_ANOTHER_OTP: "Didn't Recieve?? Resend in",
    COMMON_RESEND_ANOTHER_OTP_TAIL: "secs",
    GRM: "GRM",
    GRM_APPLICATION: "GRM-Application",
    CATEGORY_SELECTION_ERROR: "Please select Category",
    SUB_CATEGORY_SELECTION_ERROR: "Please select Sub-Category",
    SUB_SUB_CATEGORY_SELECTION_ERROR: "Please Select Sub-Sub-Category",
    SUBMIT: "Submit",
  },
  agentTrack: {
    GRM_TICKET_NUMBER: "Ticket Number",
    SCHEME_TICKET_NUMBER: "Application Number",
    TRACK_SERVICE: "Track Service",
    TRACK_SERVICE_SUBTEXT: "Choose the service under which your want to track",
    GRM_TICKET_NUMBER_ENTER: "Please enter ticket number you want to track",
    SCHEME_TICKET_NUMBER_ENTER:
      "Please enter application number you want to track",
    SELECT_TRACK_OPTION: "Please select the option you want to track",
    TRACK: "Track",
    TRACK_GRM: "GRM",
    TRACK_SCHEME: "Scheme",
    TICKET_VALIDATION_ERROR: "Please Enter Valid Ticket Number",
    SERVICE_VALIDATION_ERROR: "Please Select Service",
  },
  schemeTrack: {
    SCHEMES_TRACK: "Scheme Application Details",
  },
  appBar: {
    home: "Home",
    aboutUs: "About Us",
    schemes: "Programme and Scheme",
    majorCrops: "Major Crops",
    logout: "Log out",
    welcome: "Welcome!",
  },
  home: {
    Dashboard: "Dashboard",
    Schemes: "Schemes",
    homePageCards: {
      newFarmers: "New Farmers Registered",
      applications: "Applications Submitted for Schemes",
    },
    Advisory: "Advisory",
    Marketplace: "Marketplace",
    Grievance: "Grievance",
    Insurance: "Insurance",
    Credit: "Credit",
    ENTER_OTP: "Enter OTP",
  },
  schemes: {
    allschemes: "Schemes",
    myschemes: "My Schemes",
    searchSchemes: "Search Schemes",
    showingResultsPage: "Showing up to {{results}} results per page",
    more: "More",
    apply: "Apply",
    save: "Save & Next",
    back: "Back",
    close: "Close",
    preview: "Preview",
    registrationForm: "REGISTRATION FORM",
    agricultureSchemes: "Agriculture Schemes",
    fisheriesSchemes: "Fisheries Schemes",
    horticultureSchemes: "Horticulture Schemes",
    small: "Small",
    medium: "Medium",
    large: "Large",
    "<2acres": "<2 Acres",
    "2-5acres": "2-5 Acres",
    ">5acres": ">5 Acres",
    schemeTypes: "Scheme Types",
    farmerTypes: "Farmer Types",
    landSize: "Land Size",
    appliedBeeScreenError:
      "Only one of the components can be used in honey extraction system and food grade container. Please select yes for one",
    schemesForFarmers: "Schemes for Farmers",
    schemeDetails: "Scheme Details",
    schemeKnowMore: "Know More",
    filterBy: "Filter By",
    sortBy: "Sort By",
    stateScheme: "State Scheme",
    centralSponsored: "Central Sponsored",
    centralScheme: "Central Scheme",
    applicationWindow: "Application Window",
    schemeAbout: "About this Scheme",
    schemeApplyNow: "Apply",
    schemeVerifyFarmer: "Verify Farmer Details",
    schemeVerifyFarmerSubtext:
      "Please verify farmer DBT details before proceeding",
    farmerDBTId: "Enter Farmer’s DBT ID",
    otpSentMessage:
      "A One-Time Password has been sent to the farmer's registered mobile number ending in {{mobile}}",
    memberOtpSentMessage:
      "A One-Time Password has been sent to the member's registered mobile number",
    getOTP: "Get OTP",
    sendingOTP: "Sending OTP...",
    otpVerifieng: "Verifying OTP",
    otpSuccess: "OTP Sent!",
    otpFailed: "OTP Failed!!",
    enterOTP: "Enter One-Time Password",
    verify: "Verify",
    resendOtp: "Resend OTP",
    resendOtpIn: "Resend OTP in {{seconds}} sec",
    confirmCancel: "Farmer will be logged out!! Are you Sure??",
    confirmNavigation:
      "If logged in, Farmer will be logged out. Are you Sure??",
    applicationTypeRequired: "Please select applicant type.",
    createSchemeApplication: "Create Scheme Application",
    enterDetailsForFarmerApplication:
      "Enter the following details to create farmer application.",
    applicationForm: "Select Applicant Type",
    open: "Open",
    closed: "Closed",
    new: "New",
    default: "Default",
    gramUnit: "Gram",
    kilogramUnit: "Kilo Gram",
    latest: "Latest",
    sortAlphAsc: "A -> Z",
    sortAlphDesc: "Z -> A",
    noSchemes: "No Schemes Available",
    fetchingLocationData: "Fetching location data...",
    locationDataLoaded: "Location data loaded successfully",
    addRecord: "Add Record",
    submit: "Submit",
    confirmLandDetails: "{{component}} values will be cleared. Are you sure??",
    farmerConsent:
      "I hereby declare that I am filling this application on behalf of the farmer, and all the details shared above are correct. If any of the above information is found to be untrue, I shall be responsible for the rejection of this application, and the subsidy amount can be recovered from the farmer, making me liable for penal proceedings.",
    preview: "Preview",
    cancel: "Cancel",
    previous: "Previous",
    next: "Next",
    yes: "Yes",
    no: "No",
    totalArea: "Total Area",
    totalAppliedArea: "Total Applied Area",
    totalAreaAcre: "Total Area - {{area}} acre",
    totalAppliedAreaAcre: "Total Applied Area - {{area}} acre",
    seedQuantity: "Seed Quantity - {{quantity}} {{unit}}",
    remove: "Remove",
    submitApplication: "Submit Application",
    documentPreview: "Uploaded files",
    homePage: "Home Page",
    SCHEME_CREATE_MESSAGE: "Application has been successfully submitted",
    schemeCreated: "Applied Date : {{date}}",
    schemeNumber: "Appl. No.: {{number}}",
    applicationStatus: "Status: {{status}}",
    fileSizeInfo: "Max file size: 2MB",
    alreadyAppliedSeed: "Farmer has already applied.",
    documentContentEmpty:
      "There is currently no content available for this section. You may check back later for updates.",
    selectSeasonSeed: "Select Season",
    paginationTitle: "Showing upto {{count}} results per page",
    type: "Type",
    name: "Name",
    individualBorvelWork: "Borewell work",
    schemeSubName: "Scheme Name",
    cropCode: "Scheme Code",
    bananaCols: {
      S_No: "S. No.",
      strain: "Strain",
      appliedAreaFor: "Applied Area for (in acres)*",
    },
    NOFORM: "Application form not available at the moment. Please try again later.",
    INVALIDURL: "Unable to open the application page. Please try again later.",
  },

  schemeErrors: {
    fieldIsRequired: "Please enter value",
    invalidEmail: "Invalid email address",
    invalidIntegerFormat: "Invalid Integer Number Format",
    invalidDecimalFormat: "Invalid Decimal Number Format",
    minLengthError: "Min Required length is {{length}}",
    maxLengthError: "Max {length} characters allowed",
    minValueError: "Total Value should not be less than {{min}}",
    maxValueError: "Total Value should not exceed {{max}}",
    totalAreaError: "Total Area should not exceed {{max}}",
    totalAreaMinError: "Total Area should not be less than {{min}}",
    totalAppliedAreaError: "Total Applied Area should not exceed {{max}}",
    totalAreaShuskError:
      "Application cannot be submitted if the area applied for is more than the area in description of land",
    radioRequired: "Select one",
    checkboxRequired: "Please select checkbox",
    fileRequired: "No File Selected",
    appliedAcreageError:
      "Applied Acerage ({{floatVal}}) cannot exceed the total area ({{totalArea}}).",
    districtNotEligible: "Farmer district is not eligible for the scheme",
    pmksyError:
      "The PMKSY scheme isn't available for groups in assisted mode. Please choose 'Individual' to continue.",
    addNewRowError: "Please fill/submit the current entry.",
    addNewRowPreviewError: "Please submit the entry.",
    pleaseEnterValueMin: "Please enter at least {{min}} value(s)",
    duplicateReturnPolicy: "Please select diffrent value",
  },
  COMMON_EDIT: "Edit",
  A: "A",
  SESSION_EXPIRE_ERROR: "Your session has expired. Please log in to continue.",
  SCHEME_BENEFITS: "Scheme Benefits",
  SCHEME_HAS_ERRORS:
    "Please complete the required fields before previewing the scheme. Ensure all fields are filled in correctly.",
  SCHEME_APPLICATION_CREATE_ERROR:
    "This application cannot be submitted at this time. Please check back later.",
  SCHEME_APPLICATION_NOT_FOUND: "Scheme Application not found",
  REQUEST_IN_PROCESS: "Request in Progress",
  SUBMITTED_SUCCESSFULLY: "Submitted successfully",
  FAILED: "Failed",
  REJECTED_TRACK: "Rejected",
  SCHEME_DOWNLOAD_RECIEPT: "View and Download Receipt",
  AllContacts: "All Contacts",
  Login: "Login",
  CantLogin: "Can't login? Request Password Reset",
  AGENT_FARMER_REGISTRATIONS: "Farmer Registrations",
  AGENT_GRM_REQUESTS: "GRM Requests Raised",
  AGENT_SCHEMES_APPLIED: "Schemes Applied",
  BENIFICIARY_ID: "Beneficiary ID",
  BENIFICIARY_NAME: "Beneficiary Name",
  COMMON_CLOSE: "Close",
  COMMON_DONE: "Done",
  COMMON_HISTORY: "History",
  COMMON_NO_FILE_SELECTED: "No File Selected",
  COMMON_NEXT: "Next",
  COMMON_PREVIOUS: "Previous",
  COMMON_PROCEED_WITH_OTP: "Proceed with OTP",
  COMMON_DOWNLOAD_RECIEPT: "View and Download Receipt",
  COMMON_CONGRATS: "Congratulations !",
  COMMON_LOADING: "Loading, please wait...",
  COMMON_VIEW_ALL: "View All",
  copyright: "Copyright",
  DATE_TIME: "Date & Time",
  DFSWEB_AGENT: "Agent",
  DFSWEB_ASSETS: "Assets",
  Policy: "Policy",
  DFSWEB_ASSETS_details: "Assets Details",
  DFSWEB_CAROUSEL: "Carousel",
  DFSWEB_DFS_REGISTRATION: "Bihar Krishi Registration",
  DFSWEB_GRM: "GRM",
  DFSWEB_HELP: "Help",
  Help: "Help",
  "Help-details": "Help details",
  DFSWEB_HOME: "Home",
  DFSWEB_HISTORY: "History",
  Privacy_policy: "Privacy policy",
  DFSWEB_MANDIPRICE: "Mandi Price",
  DFSWEB_SCHEMES: "Schemes",
  DFSWEB_FAQs: "FAQs",
  DFSWEB_About: "About",
  DFSWEB_About_Bihar: "About Bihar Krishi",
  DFSWEB_Latest_Updates: "Latest Updates",
  DFSWEB_Success_Volumes: "Success Volumes",
  DFSWEB_SERVICEPROVIDER: "Service Provider",
  "Edit-profile": "Edit-Profile",
  ENTER_VALUE: "Enter Value",
  FETCH_PGR_ERROR: "Grievance Details not found, Please try again",
  FILE_UPLOADING: "Uploading",
  FILE_UPLOAD_FAILED: "Failed",
  FILE_UPLOADED: "Uploaded",
  Grm: "GRM",
  HISTORY_TICKET_NUMBER: "Application/Ticket Number",
  INVALID_TICKET_ID: "Grievance Details not found, Please try again",
  DFSWEB_TRACK: "Track",
  PERSONAL_DETAILS: "Personal Details",
  Location_DETAILS: "Location Information",
  Bank_DETAILS: "Bank Details",
  PROFILE_CREATE: "Non-DBT Registration",
  PROFILE_UPDATE: "DBT Profile Sync",
  DBT_PROFILE_CREATE: "DBT Registration",
  SCHEME_APPLY: "Apply Scheme",
  KnowMore: "Know More",
  GRM_APPLY: "Grievance Creation",
  OTP_VALIDATION_FAILED: "Invalid OTP",
  TECH_COMMON_SUBMIT: "Submit",
  DFSWEB_GRM9: "Report and Track Issue",
  passbookSessionTimeout:
    "Farmer session has expired. Please re-authenticate to access this farmer's passbook",
  dialogContent:
    "You are being redirected to an external website. Please note that Bihar Krishi Website cannot be held responsible for external websites content & privacy policies.",
  Frequently_Asked_Questions: "Frequently Asked Questions",
  govtOfBihar: "Government of Bihar",
  lastUpdate: "Last Updated",
  BiharKrishiSupport: "Bihar Krishi Support",
  KisanCallCentre: "Kisan Call Centre(Toll free)",
  DBTPortal: "DBT Portal",
  BiharSeedCertificationAgency: "Bihar State Seed Certification Agency",
  BAVAS: "Bihar Agricultural Produce Value Addition System (BAVAS)",
  DirectorateofHorticulture: "Directorate of Horticulture",
  KisanCallCentrePortal: "Kisan Call Centre Portal",
  header: "ContactInformation",
  ContactInformation: "Contact Information",
  OtherImportantLinks: "Other Important Links",
  ImportantLinks: "Important Links",
  FollowUs: "Follow Us",
  krishiAppPlay: "To avail Government schemes, Download the Bihar Krishi app",
  schemeBanner: "View all active state and central-sponsored schemes.",
  Click: "Click",
  imp_updates: "Important Updates",
  DepartofAgri: "Department of Agriculture",
  Cancel: "Cancel",
  OK: "OK",
  EMPTY_DBT_ID: "Please enter the DBT ID and then proceed.",
  INVALID_DBT_ID:
    "The entered DBT ID is invalid. Please check your input and try again.",
  FARMER_DOES_NOT_EXIST:
    "Your valid DBT ID is not registered on Bihar Krishi. Please register to avail benefits and services.",
  INVALID_OTP: "Invalid OTP",
  INCORRECT_OTP: "Invalid OTP",
  IP_ADDRESS_ERROR: "Getting your IP address, please wait...",
  KeyContacts: "Key Contacts",
  LatestNews: "Latest News",
  LearnMore: "Learn More",
  LogInToAccount: "Log in to your Account",
  NumberAboutOurSuccess:
    'Numbers that speak volumes about our <span style="color: {{color}};">Success</span>!',
  Success: "Success!",
  Skip_to_main_content: "Skip to Main Content",
  Screenreaderaccess: "Screen Reader Access",
  ScreenReader: "Screen Reader",
  Website: "Website",
  FreeCommercial: "Free / Commercial",
  OurOfferings: "Our Offerings",
  Photos: "Photos",
  QuickAction: "Quick Actions",
  ReadMore: "Read More",
  ReadLess: "Read Less",
  REPORT_A_ISSUE: "Report an Issue",
  scan_to_download: "Scan this to download Bihar Krishi Mobile App",
  Social: "Social Media",
  TICKET_NUMBER: "Ticket No.",
  TRACK_ISSUE_STATUS: "Track Issue Status",
  TYPE_OF_REQUEST: "Type of Request",
  Videos: "Videos",
  View_all_daq: "View All FAQs",
  View: "View",
  ViewAllOfferings: "View All Offerings",
  ViewAllSchemes: "View All Schemes",
  GotoRegistration: "Go to Registration",
  CreateTicket: "Create Ticket",
  ViewDetails: "View Details",
  FILE_TYPE_ERROR: "File Type Not Supported",
  FILE_UPLOAD_FAILED_ERROR: "Failed to upload. Please try again!",
  UPLOAD_FILES: "Upload Files",
  REJECTED: "REJECTED",
  SCHEME_APPLICATION_GET_ERROR: "Scheme Application Not Found",
  Mandi: "Mandi Price",
  "Price-details": "Price Details",
  COMMODITY_PRICE_HEADER: "Price",
  MANDI_COMMODITY_PRICE_TREND: "Price Trend",
  MANDI_PAST_PRICES_LABEL: "Past Prices",
  PRICE_QUINTOL: "qt",
  MANDI_PRICE_HEADER: "Mandi Price",
  MANDI_MARKET_PRICE: "Market Price",
  COMMON_APPLY: "Apply",
  COMMON_DISTRICT: "District",
  COMMON_BLOCK: "Block",
  COMMON_VILLAGE_PANCHAYAT: "Village Panchayat",
  MANDI_MARKET: "Market",
  MANDI_COMMODITY_CROP: "Crop/Commodity",
  COMMON_ID: "Id",
  COMMON_NAME: "Name",
  Manager: "Manager",
  COMMON_DELETE: "Delete",
  COMMON_DELETE_WARNING: "Are you sure you want to delete this item?",
  COMMON_DELETE_SELECTED_ITEMS_WARNING:
    "Are you sure you want to delete the selected item(s)?",
  COMMON_YES_DELETE: "Yes, Delete",
  DELETE_SUCCESSFUL: "Record deleted successfully",
  DELETE_MULTI_SUCCESSFUL: "Record(s) deleted successfully",
  "Data-cleanup": "Data Review",
  DELETE_FAILED: "Failed to delete record(s), please try again",
  DFSWEB_DATA_REVIEW: "Data Review",
  DFSWEB_DATA_REVIEW_DESC: "Manage data from here",
  MANDI_FROM_DATE: "From Date",
  MANDI_TO_DATE: "To Date",
  COMMON_DATE: "Date",
  MANDI_COMMODITY: "Commodity",
  MANDI_VARIETY: "Variety",
  MANDI_PRICE: "Price",
  MANDI_MIN_PRICE: "Min Price",
  MANDI_MAX_PRICE: "Max Price",
  MANDI_ERROR_LOADING_MARKET_DATA: "Error Loading Data",
  MANDI_NO_MARKET_DATA: "No Data Available",
  NoRecordFound: "No suggestions found",
  searchLocation: "Search Location",
  MANDI_DATE_FILTER_ERROR: "Please Select",
  SELECT_Date: "Select Date",
  VERIFY_FARMER: "Verify Farmer Details",
  APPLICATION_FORM: "Application Form",
  PREVIEW_SUBMIT: "Preview & Submit",
  Categories: "Categories",
  QuickFilters: "Quick Filters",
  Filters: "Filters",
  Privacypolicy: "Privacy Policy/Terms of Use Page.",
  SearchAssets: "Search assets",
  Search: "Search",
  SearchQuestion: "Search Questions",
  SearchContact: "Search Contacts",
  contactPerson: "Contact Person",
  activities: "Business Areas",
  cropName: "Crop Name: ",
  CROP_NAME: "Crop Name",
  sourceText: "Source: ",
  sourceWeather: "Bihar Mausam Sewa Kendra",
  Assets_home_text:
    "Welcome to the Agri Resource section, where you can easily view categorized information on various agricultural institutions and resources available across all districts of Bihar. Here, you can access details and contact information for agricultural resources available throughout the state. Additionally, using the in-app call feature, you can directly call any contact number provided in this section to get in touch with the relevant person instantly.",
  farmerRegistration: {
    PERSONAL_DETAILS: "PERSONAL DETAILS",
    DBT_ID: "DBT ID",
    FARMER_NAME: "Farmer's name",
    "FATHER/MOTHER/HUSBAND_NAME": "Father/Mother/Husband Name",
    DATE_OF_BIRTH: "Date of Birth",
    AGE: "Age",
    GENDER: "Gender",
    MOBILE_NUMBER: "Mobile Number",
    FARMER_TYPE: "Farmer's type",
    CASTE_CATEGORY: "Caste category",
    FARMER_CATEGORY: "Farmer's category",
    DISTRICT: "District",
    BLOCK: "Block",
    VILLAGE_PANCHAYAT: "Village Panchayat",
    VILLAGE: "Village",
    PINCODE: "Pincode",
    RESEND_OTP: "Resend OTP",
    PLEASE_VERIFY: "Please Verify",
    // SENT_OTP_TO_MOBILE_NO:
    //   "We have sent you a One-Time Password to your registered mobile number {number}.",
    OTP_SENT_TO_MOBILE_NO_1:
      "A One-Time Password has been sent to the farmer's registered mobile number ending in",
    OTP_SENT_TO_MOBILE_NO_2: "",
    VERIFY: "Verify",
    DBT_SYNC: "DBT Sync",
    RETRY1: "Retry in",
    RETRY2: "",
    SUBMIT: "Submit",
    CHANGE_PHOTO: "Change Photo",
    DIDNOT_RECIEVE: "Didn't Recieve?",
    FARMER_ALREADY_EXIST: "Farmer already exist in Bihar Krishi",
    BANK_NAME: "Bank Name ",
    ACCOUNT_NUMBER: "Bank Account Number",
    IFSC_CODE: "IFSC Code",
    BANK_BRANCH_ADDRESS: "Bank Branch Address",
    CONGRATULATIONS: "Congratulations!",
    REGISTRATION_UPDATE_SUCCESSFUL:
      "Your Bihar Krishi registration has been successfully updated",
    REGISTRATION_CREATE_SUCCESSFUL:
      "Your Bihar Krishi registration has been successfully created",
    OWN: "Own",
    RENTED: "Rented",
    MIXED: "Own Land + Rented Land",
    SMALL: "Small Farmer (1-2 hectares)",
    MEDIUM: "Marginal Farmer (Less than 1 hectare)",
    LARGE: "Large Farmer (more than 2 hectares)",
    MALE: "Male",
    FEMALE: "Female",
    OTHER: "Other",
    MINORITY: "Minority",
    SC: "Scheduled Castes",
    ST: "Scheduled Tribes",
    OBC: "Other Backward Classes",
    BACKWARD: "Backward Classes",
    GENERAL: "General",
    REQUIRED_FARMER_NAME: "Please write name of farmer",
    REQUIRED_RELATIVE_NAME: "Please write name of farmer's relative",
    REQUIRED_DOB: "Please write DOB",
    REQUIRED_AGE: "Please write age of farmer",
    REQUIRED_GENDER: "Please select gender of farmer",
    REQUIRED_MOBILE_NUMBER: "Please write the mobile no.",
    MAXLENGTH_MOBILE_NUMBER: "Mobile number must not exceed 10 characters",
    MINLENGTH_MOBILE_NUMBER: "Mobile number must be at least 10 characters",
    REQUIRED_FARMER_TYPE: "Please select type of farmer",
    REQUIRED_CASTE_CATEGORY: "Please select caste category of farmer",
    REQUIRED_FARMER_CATEGORY: "Please select category of farmer",
    REQUIRED_DISTRICT: "Please select district",
    REQUIRED_BLOCK: "Please select block",
    REQUIRED_PANCHAYAT: "Please select panchayat",
    REQUIRED_VILLAGE: "Please select category of farmer",
    PINCODE_PATTERN: "Enter a valid pincode of 6 digits",
    PINCODE_REQUIRED: "Please enter the pincode",
    NOT_AVAILABLE: "Not Available",
    MOBILE_MAXLENGTH: "Mobile number must not exceed 10 characters",
    FARMER_NAME_MINLENGTH: "Farmer name should be at least 2 characters",
    FARMER_RELATIVE_NAME_MAXLENGTH:
      "Farmer relative name should not be more then 100 characters",
    MOBILE_MINLENGTH: "Mobile number must be at least 10 characters",
    UNEXPECTED_ERROR: "An unexpected error occurred.",
    UPDATE_NOT_SUPPORTED:
      "Sync failed: Mobile number has changed. Please contact support.",
    PHOTO_UPLOAD_SUCCESS: "Photo Uploaded Successfully",
    EG_FILESTORE_INVALID_INPUT:
      "Invalid file type. Please upload: [JPG, JPEG, PNG].",
    OTP_SEND_FAILED: "Failed to send OTP. Please try again.",
    OTP_RESEND_FAILED: "Failed to resend OTP. Please try again.",
    INVALID_DBT_ID:
      "The entered DBT ID is invalid. Please check your input and try again.",
    RE_LOGIN: "Re-Login",
    RE_LOGIN_MESSAGE: "Your mobile number has been updated with the number in your DBT account, kindly logout",
    RE_LOGIN_HEADER: "We're sorry, DBT ID & Mobile number don't match"
  },
  Humidity: "Humidity",
  WindDirection: "Wind Direction",
  WindSpeed: "Wind Speed",
  Rain: "Rain",
  Max_MinTemp: "Max / Min Temp.",
  Date: "Date",
  day_forcast: "3-Day Forecast",
  TodayWeather: "Today's weather",
  N: "N",
  E: "E",
  S: "S",
  W: "W",
  NE: "NE",
  SE: "SE",
  SW: "SW",
  NW: "NW",
  Weatherdata: "Weather",
  Sun: "Sunday",
  Mon: "Monday",
  Tue: "Tuesday",
  Wed: "Wednesday",
  Thur: "Thursday",
  Fri: "Friday",
  Sat: "Saturday",
  get_direction: "Get Directions",
  Bihar: "Bihar",
  Q: "Q",
  A: "A",
  Acc: "A",
  COMMON_USERNAME: "Username",
  COMMON_PASSWORD: "Password",
  COMMON_ENTER_PASSWORD: "",
  notEligible:
    "Sorry, this location isn't available. Please choose a different one.",
  notAvaliable:
    "Sorry! Location details doesn't match. Please contact support.",
  Complaintdetails: "Grievance Details",
  Sitemap: "Site Map",
  landingPage: "Landing Page",
  Footer: "Footer",
  Storage: "Storage",
  Office: "Agri Offices",
  Education: "Agri Institutes",
  Bazaar: "Bazaar",
  OtherAssets: "Other Assets",
  Cold_Storage: "Cold Storage",
  PACS: "PACS",
  Agri_Godowns: "Agri Godowns",
  Panchayat_Office: "Panchayat Office",
  "e-Kisan_Bhavan": "e-KISAN Bhawan",
  DAO_Office: "DAO Office",
  KVK: "KVK",
  Agriculture_College: "Agriculture College",
  Pashu_Bazaar: "Pashu Bazar",
  Market_Nodes: "Market Nodes",
  Agri_Input_Shops: "Agri-Input Shops",
  Agriculture_Farms: "Agriculture Farms",
  Rice_Mill: "Rice Mill",
  Custom_Hiring_Center: "Custom Hiring Centre",
  Traders: "Traders",
  "Fpo-Farmers_Producers_Services": "Farmers Producers Organisation",
  Commodity_Price: "Commodity Price",
  Contact_US: "Contact Us",
  TrackScheme: "Scheme Track",
  FARMER_PASSBOOK: "Farmer Passbook",
  "Farmer-passbook": "Farmer Passbook",
  "Agent-access": "Verification",
  PROCESSING_PASSBOOK_INFO:
    "Fetching your passbook. This may take a moment, please check back later.",
  Choose_Year: "Choose Year",
  SL_NO: "Sl.No",
  Sub_Scheme_Name: "Sub Scheme Name",
  Application_Date: "Application Date",
  Subsidy_Type: "Subsidy Type",
  Settlement_Date: "Settlement Date",
  Benefit_Allocation: "Benefit Allocation",
  Download_PDF: "Download PDF",
  help: {
    SpeaktoDOAOfficials: "Speak to DOA Officials/Call us",
    CallCenters: "Call Centres",
    DBTIDRelatedServices: "DBT ID Related Services",
    OtherRelevantServices: "Other Relevant Services",
    MandiAnalysts: "Mandi Analysts",
    CertificationInspectors: "Certification Inspectors(Seed/Organic)",
    SAO: "SAO",
    AgricultureCoordinator: "Agriculture coordinator",
    KisanSalahkar: "Kisan Salahkar",
    NominatedACforMarketNodes: "Nominated AC for Market Nodes",
    AssistantDirectorofPlantProtection:
      "Assistant Director of Plant Protection",
    EthanolIndustries: "Ethanol Industries",
    JaivikFPOs: "Jaivik FPOs",
    ReportTechnicalissue: "Report Technical issue",
    Foodprocessing: "Food processing ",
    bac: "BAC",
    availableTimings: "Available Timings",
    availableDays: "Available Days",
    Capacity: "Capacity",
    Status: "Status",
    status: "Status",
    address: "Address",
    capacity: "Capacity",
    establishYear: "Establish Year",
    productName: "Product Name",
    majorCrops: "Major Crops",
    commoditiesTraded: "Commodities Traded",
    oci: "Organic Certification Inspector",
    si: "Seed Certification Inspector",
    si1: "Seed Certification Inspector- 1",
    si2: "Seed Certification Inspector- 2",
    si3: "Seed Certification Inspector- 3",
    dao: "DAO",
    dho: "DHO",
    ade: "ADE",
    adc: "ADC",
    noDataFound: "No data found. Please check back later or refine your search",
  },
  //soil health
  Soil_health: "Soil Health",
  soil_health_Detail: "Soil Health Details",
  "Soil-health-details": "Soil Health Details",
  soil_health_labs: "Soil Testing Labs",
  soil_health_card: "Soil Health Card",
  agriAdvisory: "Agri Advisory",
  filterByDistrict: "Filter by District",
  Distance: "Distance",
  approx: "approx",
  Download: "Download",
  FinancialYears: "Financial Years",
  TestGrid: "Test Grid",
  KhataKasara: "Khata/Khasara",
  NoOptions: "No Options",
  selectAtLeast1NPK:
    " Please select at least one of Nitrogen, Phosphate, or Potash.",
  selectAtLeast1Crop:
    "Please select at least one crop and its corresponding yield.",
  GenerateReport: "Generate Report",
  Potash: "Potash",
  Phosphate: "Phosphate",
  Nitrogen: "Nitrogen",
  Yield: "Yield",
  Crop: "Crop",
  selectCrop: " Please select Crops and target Yields",
  LandSize: "Land Size",
  Check_more_crop: "Check more crop",
  selectNPK: " Please select fertilizer, you wish to use",
  NPKGroup: "N.P.K Group",
  name: "Name",
  SoilHealthId: "Soil Health Card id:",
  Validity: "Validity:",
  DataAnalysis: "Data Analysis",
  Resource: "Resource",
  testDate: "Test Date:",
  BasedInput: "Data Analysis: Data shown based on Inputs:",
  Share: "Share",
  whereShare: "Please select where you want to share the soil details",
  "Farmer-details": "Verify Farmer Details",
  selectAnotherYear:
    "Please select another financial year to view the records.",
  SessionTimeout: "Farmer session has expired.",
  selectArea: "Please select Area and Unit",
  whatsAppSuccess:
    "WhatsApp message sent successfully. Please check after 2-3 minutes",
  whatsAppFailure:
    "There was an issue with sending the WhatsApp message. Please try again later.",
  farmersDashboard: "Farmers Registrations",
  schemesApplications: "Scheme Applications",
  grmDashboard: "GRM",
  COMMON_AMOUNT: "Amount",
  Radio: "Radio",
  Bihar_Krishi_Radio: "Tune in to Bihar Krishi Radio",
  Now_playing_Radio: "Now Playing Bihar Krishi Radio",
  Play: "Play",
  Pause: "Pause",
  Stop: "Stop",
  Mute: "Mute",
  Unmute: "Unmute",
  Volume: "Volume",
  Reviews: "Reviews",
  Percentage: "Percentage",
  Star: "Star",
  Stars: "Stars",
  selectAValue: "Please select a value",
  Farmer: "Farmer",
  Others: "Others",
  COMMON_MOBILE: "Enter Mobile Number",
  COMMON_LOGIN_TYPE: "Login Type",
  dbt_dfs_registered_phone: "DBT or DFS -registered mobile number",
  otp_sent_message_1:
    "We have sent you a One-Time Password to your registered mobile number {{maskedMobile}}.",
  otp_sent_message_2:"",
  COMMON_MOBILE_INVALID: "This number is not registered",
  All_Schemes:"All Schemes",
  Applied_Schemes:"Applied Schemes",
  Group_description: "Group Description",
  "Acreage_(in_Acres)": "Acreage (in Acres)",
  "Applied_Unit_(125_Sq.m._Per_Unit)": "Applied Unit (125 Sq.m. Per Unit)",
  remarks:"Remarks",
  Refresh:"Refresh",
  requiredRegistrationGRM:
    'DBT registration is mandatory for applying to schemes of Agriculture department. Please register on DBT portal before applying',
  Date_of_Application: "Date of Application",
  APPLICATION_STATUS: "Application Status",
  Applied:"Applied",
  address:"Address",
  COMMON_MOBILE_REQUIRED: "Please enter mobile number",
  MOBILE_NUM_CHANGE_1: "Kindly note, The DBT ID entered by you is linked with another mobile no {{maskedMobileNumber}}. If this is your mobile number then kindly enter the complete mobile number to proceed. Please note that profile details associated with this mobile number will be mapped to this profile.",
  MOBILE_NUM_CHANGE_2: "If you are sure, then Please click on continue button or click on cancel button to go back",
  FETCHED_DATA: "Data Fetched Successfully",
  MOBILE_MISMATCH: "Mobile numbers do not match",
  MOBILE_ALREADY_REGISTERED: "Mobile number is already registered. Please login with this Mobile number.",
  selfRegistration: {
    haveDBT: "Do you have DBT ID?",
    registerDBT: "Do you want to register with D.B.T.?",
    dbtLinkHelper: "Click on the link given below to register in the D.B.T. portal",
    dbtDetails: "DBT Details",
    fetchData: "Fetch DBT Data",
    fetchPermission: "Would you like to get details from D.B.T. portal?",
    dbtInputLabel: "Farmer D.B.T. Registration number (13 digit)", 
    continue: "Continue",
    mobileInputLabel: "Mobile Number",
    mobileInputHelper: "Use the DBT registered mobile number {{maskedMobile}} for signup",
    back: "Back",
    notEligible: "Sorry! Location details doesn't match. Please contact support.",
    DBT_ERROR: "Error fetching dbt details from the server, please try again after sometime",
  },
  Farmer_Registration: "Farmer-Registration",
  kg: "kg",
};
